export const enum EDepositStatus {
  Collected = 'payment_deposit_collected',
  ToCollect = 'payment_deposit_to_collect',
  ToReturn = 'payment_deposit_to_return',
  Returned = 'payment_deposit_returned',
  NoDeposit = 'payment_deposit_no_deposit',
}
